<template>
  <div class="container">
    <CommonFrame
      :workNo="workNo"
      :btns="btns"
      :node="node"
      :breadcrumb="breadcrumb"
      :endStatus="approvalParams.endStatus"
      :approvalTabStatus="approvalParams.approvalTabStatus"
    >
      <div slot="info">
        <div class="info-container">
          <div class="info-item">
            <h4>退货单号：{{saleRefund.code}}</h4>
            <div class="info-wrap">
              <div class="info-wrap-item">所属门店：{{saleRefund.storeName}}</div>
              <div class="info-wrap-item">创建时间：{{saleRefund.createTime}}</div>
              <div class="info-wrap-item">创建人：{{saleRefund.createUserName}}</div>
            </div>
          </div>
        </div>
      </div>
      <div slot="tableInfo">
        <lk-card title="退货单信息" class="other-card">
          <lk-form :label-width='134' label-position="right">
            <!-- <lk-row :gutter='16'>
              <lk-col span="7">
                <lk-form-item label="退款方式:">
                  <span>{{saleRefund.proceedsTypeName}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="总金额:">
                  <div>{{saleRefund.amount}}</div>
                </lk-form-item>
              </lk-col>
            </lk-row> -->
            <lk-row :gutter='16'>
              <lk-col span="23">
                <lk-form-item label="退回商品:">
                  <lk-table :data="tableData" :columns="rejectColumn" class="rejectTable" border/>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="退货金额合计:">
                  <span>{{saleRefund.amount}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" >
                <lk-form-item label="退款合计:">
                  <span>{{saleRefund.amount}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span="7">
                <lk-form-item label="退款信息:">
                  <div class="refundMethod" v-for="item in refundList">
                    <div class="refundCell">{{item.proceedsTypeName}}</div>
                    <div class="refundCell">{{item.amount}}</div>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16' v-if="refundData != undefined && refundData.length>0">
              <lk-col span="15">
                <lk-form-item label="预收核销退回:">
                  <lk-table :data="refundData" :columns="refundColum" class="rejectTable" border/>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span="7">
                <lk-form-item label="验收记录:">
                  <div>{{saleRefund.inspectRecord}}</div>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span="7">
                <lk-form-item label="验收人员:">
                  <div>{{saleRefund.refundInspector}}</div>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </CommonFrame>
  </div>
</template>

<script>
import axios from 'axios';
import utils from '@/libs/utils';
import EditReturnExpand from '@/views/aftersale/EditReturnExpand.vue';
import CommonFrame from '../commonFrame.vue';

export default {
  name: 'SaleRefundApproval',
  props: {
    approvalParams: {
      type: Object,
    },
  },
  components: {
    CommonFrame,
  },
  data() {
    return {
      refundList: [],
      saleRefund: {},
      refundData: [],
      refundColum: [
        {
          title: '序号',
          minWidth: 80,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '收款单号',
          minWidth: 116,
          key: 'depositCode',
        },
        {
          title: '付款人',
          minWidth: 116,
          key: 'paymentUserName',
        },
        {
          title: '联系方式',
          minWidth: 116,
          key: 'paymentUserPhone',
        },
        {
          title: '核销金额',
          minWidth: 116,
          key: 'verificationAmount',
        },
        {
          title: '退款金额',
          minWidth: 130,
          key: 'refundAmount',
        },
      ],
      rejectColumn: [
        {
          type: 'expand',
          width: 46,
          render: (h, { row }) => h(EditReturnExpand,
            {
              props: {
                row,
              },
            }),
        },
        {
          title: '序号',
          minWidth: 80,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '销售单号',
          minWidth: 116,
          key: 'saleOrderDetailOrderNo',
        },
        {
          title: '通用名称',
          minWidth: 116,
          key: 'saleRefundDetailApprovedDrugNames',
        },
        {
          title: '单价',
          minWidth: 116,
          key: 'saleRefundDetailRefundPrice',
        },
        {
          title: '销售数量',
          minWidth: 116,
          key: 'saleOrderDetailGoodsCount',
        },
        {
          title: '仓库',
          minWidth: 116,
          key: 'saleRefundDetailWareHouseName',
        },
        {
          title: '货位',
          minWidth: 116,
          key: 'saleRefundDetailLocationCode',
        },
        {
          title: '退货数量',
          minWidth: 130,
          key: 'saleRefundDetailRefundNum',
        },
        {
          title: '退货金额',
          minWidth: 130,
          key: 'saleRefundDetailRefundAmount',
        },
        {
          title: '退货原因',
          minWidth: 130,
          key: 'saleRefundDetailRefundReason',
        },
      ],
      tableData: [],
      page: 1,
      size: 10,
      count: 0,
      workNo: '',
      node: '',
      breadcrumb: [
        {
          name: 'work',
          title: '审批管理',
        },
        {
          name: 'approvalEdit',
          title: '销售退货单审批',
        },
      ],
      btns: [
        {
          name: 'reject',
          text: '驳回',
          type: 'default',
        },
        {
          name: 'pass',
          text: '通过',
          type: 'primary',
        },
      ],
    };
  },
  methods: {
    getData() {
      axios.get(this.approvalParams.businessUrl).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          data.saleRefund.createTime = utils.formatTime(data.saleRefund.createTime, 'YYYY/MM/DD HH:mm');
          this.saleRefund = data.saleRefund;
          this.refundList = data.saleOrderProceeds;
          if (data.financeDepositInfos != undefined) {
            this.refundData = data.financeDepositInfos;
          }
          data.saleRefundDetailVoList.forEach((vo) => {
            const result = {};
            utils.exchangeTable(vo, result);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },

  mounted() {
    this.getData();
  },
  created() {
    this.workNo = this.approvalParams.workNo;
    this.node = this.approvalParams.node;
  },
};
</script>

<style lang="less" scoped>
.info-wrap{
  display: flex;
  .info-wrap-item{
    margin-right: 32px;
  }
}
.refundMethod {
  display: flex;
}
.refundCell {
  width: 300px;
}
</style>
